import React from "react";

import "./LoginNav.css";

export const LoginNav = () => {
  return (
    <>
      <div className="l-nav">
        <a href="/" className="l-brand-link">
          TimeBase
        </a>
      </div>
    </>
  );
};
